import { ReduxService } from 'dashboard-services/services';

import { searchActions } from 'actions/modules/tools';

export const searchlInitialState = {
  searchAllOpen: false,
  searchAllQuery: undefined,
}

export default (state = searchlInitialState, action) => {
  switch (action.type) {
    case searchActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}